import { Hotel, Users, UtensilsCrossed, Sparkles, Bus, ArrowRight } from "lucide-react";
import OmbelineContactPopover from "@/components/thales/OmbelineContactPopover";
import { useArkemaLang } from "@/components/thales/i18n";

const ThalesServices = () => {
  const { t } = useArkemaLang();
  const services = [
    { icon: UtensilsCrossed, title: t("services.catering") },
    { icon: Sparkles, title: t("services.animation") },
    { icon: Bus, title: t("services.transport") },
    { icon: Hotel, title: t("services.hotels") },
    { icon: Users, title: t("services.coworking") },
  ];
  return (
    <section className="py-4 md:py-6 px-4 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="relative bg-gradient-to-br from-[#fafbf5] to-[#f0f3e8] rounded-3xl p-6 sm:p-10 md:p-12 border border-black/5 overflow-hidden">
          <div className="relative grid lg:grid-cols-12 gap-8 lg:gap-10 items-center">
            {/* Left: copy */}
            <div className="lg:col-span-5">
              <h2 className="text-2xl sm:text-3xl lg:text-[40px] font-bold text-[#111111] leading-[1.15] mb-3">
                {t("services.title")}
              </h2>
              <p className="text-sm md:text-base text-[#6b7280] leading-relaxed max-w-md">
                {t("services.paragraph")}
              </p>
            </div>

            {/* Right: services row */}
            <div className="lg:col-span-7">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-black/5 rounded-2xl overflow-hidden border border-black/5">
                {services.map((service, index) => {
                  const Icon = service.icon;
                  return (
                    <div
                      key={index}
                      className="group bg-white hover:bg-[#fafbf5] transition-colors p-4 lg:p-5 flex flex-col items-center text-center gap-3 cursor-default"
                    >
                      <div className="w-11 h-11 rounded-full bg-[#f5f7f0] border border-black/5 flex items-center justify-center transition-all duration-300 group-hover:bg-[#C6E278] group-hover:border-[#C6E278] group-hover:-translate-y-0.5">
                        <Icon className="w-5 h-5 text-[#111111]" />
                      </div>
                      <div className="text-xs lg:text-[13px] text-[#111111] leading-snug font-medium">
                        {service.title}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Footer line */}
              <OmbelineContactPopover align="start">
                <button
                  type="button"
                  className="mt-4 inline-flex items-center gap-1.5 text-xs text-[#6b7280] hover:text-[#5a7a1f] transition-colors group"
                >
                  {t("services.more")}
                  <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
                </button>
              </OmbelineContactPopover>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThalesServices;
